let currentId = 1;

export default function getUniqueId() {
	return currentId++;
}
